import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FuseCardComponent } from '@fuse/components/card';
import { TFMService } from 'app/mock-api/tfm.service';
import { HeadingSectionType01Component } from '../../heading-section/heading_section-type01/heading_section-type01.component';
import { NgClass, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { FooterType03Component } from 'app/layout/common/footer/footer-type03/footer-type03.component';

@Component({
  selector: 'brochure-type01',
  standalone: true,
  imports: [MatIconModule,FuseCardComponent,HeadingSectionType01Component, NgStyle, NgClass,NgFor, RouterLink,MatTooltipModule,FooterType03Component],
  templateUrl: './brochure-type01.component.html',
  styleUrl: './brochure-type01.component.scss'
})
export class BrochureType01Component implements OnInit {

  public view: any = {

  }

  constructor(public _tfmService: TFMService,private _cd: ChangeDetectorRef) {
    
      
  }

  ngOnInit(): void {
  }
}

